import { createSlice } from '@reduxjs/toolkit';
import { FEATURE_TOGGLES } from 'constants/featureToggles';
import { getFeatureToggles } from './featureTogglesApi';

const initialState = {
    toggles: Object.values(FEATURE_TOGGLES).map((value) => ({ name: value, isEnabled: false })), //all toggles disabled by default
};

const featureTogglesSlice = createSlice({
    name: 'featureToggles',
    initialState,
    reducers: {},
    extraReducers: {
        [getFeatureToggles.fulfilled]: (state, action) => {
            state.toggles = action.payload;
        },
    },
});

export default featureTogglesSlice.reducer;
